export const idACorreo = (id) =>{

    let noBajo = id.replaceAll('_', '@')
    let noMedio = noBajo.replaceAll('-', '.')

    return noMedio
}